import script from "./DayCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DayCard.vue?vue&type=script&setup=true&lang=js"

import "./DayCard.vue?vue&type=style&index=0&id=b36e82f0&lang=css"

const __exports__ = script;

export default __exports__